import Vue from 'vue'
import { configureHttp } from './http'
import App from './App'
import router from './router'
import store from './store'
import i18n from './localization'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import { EventBus } from './utilites/eventBus'
import PortalVue from 'portal-vue'
import VIcon from "./utilites/commonUi/VIcon.vue";

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(PortalVue);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas);
library.add(far);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-icon', VIcon);

Vue.config.productionTip = false;

// URL берется из Env переменной
// В случае с local dev - dev.env
// В случае с prod - prod.env подставляется при сборке
const API_URL = process.env.ROOT_API;

configureHttp(Vue.http, {apiUrl: API_URL, store, router, eventBus: EventBus});

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js